export default "__VITE_ASSET__DdDErep7__"